import i18n from '@/i18n';
import { formatPrice as utilsFormatPrice, formatPercent as utilsFormatPercent } from './utils';
import moment from '@/moment/moment';
import { t } from 'i18next';
import { SUPPORTED_LANGUAGES } from '@/constants/locales';

const formatter = {
    locale: i18n.language,
    currency: 'EUR',
    async changeLanguageAndSyncFormatter(newLang) {
        await i18n.changeLanguage(newLang);
        this.locale = newLang;
    },
    formatPrice(price, options = {}) {
        return utilsFormatPrice(price, {
            locale: this.locale,
            currency: this.currency,
            ...options,
        });
    },

    formatPercent(value, options = {}) {
        return utilsFormatPercent(value, {
            locale: this.locale,
            ...options
        })
    },

    formatNumber(number) {
        return new Intl.NumberFormat(this.locale).format(number);
    },

    formatValidityDuration(validity_days, validity_months, validity_years) {
        const validityDuration = moment.duration({
            days: validity_days,
            months: validity_months,
            years: validity_years,
        });
        const hasValidityDuration = validityDuration.asDays() > 0;

        return t('shop:validity_duration', {
            duration: validityDuration.humanize(),
            context: hasValidityDuration ? '' : 'forever',
        });
    },

    withLabelColon(key) {
        const label = t(key);
        const colonByLocale = {
            fr: ' : ',
            en: ': ',
            de: ': ',
            nl: '： ',
        };

        const separator = colonByLocale[this.locale] || ': ';

        return `${label}${separator}`;
    },

    formatDateRange(startDate, endDate, format = 'LL') {
        const start = moment(startDate).locale(this.locale).format(format);
        const end = moment(endDate).locale(this.locale).format(format);
        return t('date_range', { start, end });
    },
    formatDate(date, format = 'MMMM YYYY') {
        if (!date)
            return '-';
        date = moment(date);
        if (!date.isValid())
            return '-';
        return date.format(format);
    },
    // Returns an array of localized weekday names (starting from Monday), optionally capitalized.
    // getWeekdays(capitalize = false) {
    //     return Array.from({ length: 7 }, (_, i) => {
    //         const day = moment().locale(this.locale).isoWeekday(i + 1).format('dddd');
    //         return capitalize ? day.charAt(0).toUpperCase() + day.slice(1) : day;
    //     });
    // },
    getWeekdays(capitalize = false) {
        const formatter = new Intl.DateTimeFormat(this.locale, { weekday: 'long' });

        // Crée une semaine à partir du lundi
        const weekdays = Array.from({ length: 7 }, (_, i) => {
            // Commencer un lundi (1), donc 1970-01-05 est un lundi
            const baseDate = new Date(1970, 0, 5 + i);
            let day = formatter.format(baseDate);
            return capitalize ? day.charAt(0).toUpperCase() + day.slice(1) : day;
        });

        return weekdays;
    },

    getLanguageName(languageCode) {
        if (!Object.values(SUPPORTED_LANGUAGES).includes(languageCode)) {
            console.warn(`Language code ${languageCode} has no name set.`);
            return t('misc:languages.unsupported');
        }
        return t(`misc:languages.${languageCode}`)

    },
    translate(key, options) {
        return i18n.t(key, options);
    }
};

i18n.on('languageChanged', (language) => {
    formatter.locale = language;
});

export default formatter;



// WEBPACK FOOTER //
// ./src/helpers/formatter.js